import { negocioData } from './mock/negocioMock.js';

angular.module('Toke').factory('negocioRepository', function ($q) {

    function getNegocio() {
        return $q.resolve(negocioData);
    }

    // para lista futura
    // function getNegocioFromList() {
    //
    //     const listUrl =
    //         baseUrl +
    //         "/_api/web/lists/getbytitle('Intro')/items" +
    //         "?$select=Title,Url,ParentId,Order,IsActive" +
    //         "&$orderby=Order asc";
    //
    //     return $http({
    //         method: 'GET',
    //         url: listUrl,
    //         headers: {
    //             Accept: 'application/json;odata=nometadata'
    //         }
    //     }).then(function (response) {
    //         return response.data.value;
    //     });
    // }

    return {
        getNegocio: getNegocio
    };
});
